/**
 * Canonical resource-load error projection for descriptor-driven pages.
 *
 * List, detail, and form route surfaces consume this component so HTTP access
 * failures cannot drift into generic infrastructure errors. It does not own
 * session-expiry redirects or mutation errors. Keep status-to-state mapping
 * centralized and fail closed when adding new resource page types.
 */
import {
  PageErrorState,
  PageForbiddenState,
  PageNotFoundState,
} from '../states';

interface ResourceLoadErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

interface ResourceLoadError {
  status?: number;
  code?: string;
}

export function ResourceLoadErrorState({
  error,
  onRetry,
}: ResourceLoadErrorStateProps) {
  const resourceError = error as ResourceLoadError | null | undefined;
  if (resourceError?.status === 403) {
    return (
      <PageForbiddenState
        reasonCode={resourceError.code ?? 'AUTH_FORBIDDEN'}
      />
    );
  }
  if (resourceError?.status === 404) {
    return <PageNotFoundState />;
  }
  return <PageErrorState onRetry={onRetry} />;
}
